module.exports = __webpack_public_path__ + "static/a-81f1587b8247ce1499d97303081602fc.png";